import { NOTIFICATION_TYPE_ALERT } from '@/modules/Notification/notification';
import notificationService from '@/services/API/notification';
import Vue from 'vue';

// owner_id
// target_id
// target_class
// type
// category

export default {
  name: 'notification',
  namespaced: true,
  state: {
    stats: [],
    notification: null,

    allNotifications: [],
  },
  getters: {
    total: (state) => state.stats.reduce((acc, current) => {
      acc += current.count;
      return acc;
    }, 0),

    notification: (state) => state.notification,
    notifications: (state) => state.notifications,
    allNotifications: (state) => state.allNotifications,
  },
  actions: {
    async connect({ dispatch, rootGetters }) {
      await dispatch('centrifuge/connectNotifications', null, { root: true });
      const params = {
        channel: `notification#${rootGetters['auth/getUserData'].id}`,
        fn: (data) => {
          dispatch('notificationManager', data);
        },
      };
      dispatch('getStats');
      dispatch('centrifuge/subscribeNotifications', params, { root: true });
    },

    getStats({ commit }) {
      const params = {
        'search[view]': 0,
      };
      notificationService.getNotificationStats(params).then((response) => {
        commit('SET_STATS', response.data.data);
      });
    },
    notificationManager({ commit }, data) {
      commit('ADD_NOTIFICATION', data.data);

      const notificationType = data.data?.type || 0;
      const { text, type } = NOTIFICATION_TYPE_ALERT[notificationType];

      Vue.$toast(text, {
        position: 'bottom-right',
        timeout: 15000,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        closeOnClick: false,
        closeButton: 'button',
        icon: true,
        rtl: false,
        type,
        onClick: (close) => {
          Vue.$router.push('/notification');
          close();
        },
      });
    },

  },
  mutations: {
    SET_STATS(state, data) {
      state.stats = data;
    },
    SET_ALL_NOTIFICATIONS(state, data) {
      state.allNotifications = data;
    },
    ADD_NOTIFICATION(state, data) {
      const newStats = [...state.stats];
      const { category } = data;
      const index = newStats.findIndex((c) => c.category === category);
      if (index !== -1) {
        newStats[index].count += 1;
        state.stats = newStats;
      }
      state.notification = data;
      state.allNotifications.unshift(data);
    },

  },
};
